import React from "react";
import { cn } from "@/lib/utils/cn";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "info" | "premium";
  size?: "sm" | "default";
  dot?: boolean;
}

export function Badge({ className, variant = "default", size = "default", dot, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border font-medium transition-colors duration-3 ease focus:outline-none focus-visible:ring-sm focus-visible:ring-offset-1",
        {
          "border-border bg-foreground text-background": variant === "default",
          "border-border bg-surface-tertiary text-fg-secondary": variant === "secondary",
          "border-accent-red/20 bg-accent-red/10 text-accent-red": variant === "destructive",
          "border-border bg-surface text-fg": variant === "outline",
          "border-accent-green/20 bg-accent-green/10 text-accent-green": variant === "success",
          "border-accent-amber/20 bg-accent-amber/10 text-accent-amber": variant === "warning",
          "border-accent-blue/20 bg-accent-blue/10 text-accent-blue": variant === "info",
          "border-primary-200/30 bg-primary-50 text-primary-700": variant === "premium",
        },
        {
          "px-1.5 py-0.5 text-1 tracking-wider": size === "sm",
          "px-2.5 py-0.5 text-2 tracking-wide": size === "default",
        },
        className
      )}
      {...props}
    >
      {dot && <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-current opacity-70" />}
      {children}
    </span>
  );
}
Badge.displayName = "Badge";
